import { useDispatch } from 'react-redux';
import './Filter.css';
import { changeFilterActive, deleteFilter } from '../../features/searchBar/searchBarSlice';

export default function Filter({filter}) {
    const dispatch = useDispatch();

    const handleToggleFilter = (event) => {
        dispatch(changeFilterActive(filter.id));
    }

    const handleDeleteFilterClick = (event) => {
        dispatch(deleteFilter(filter.id));
    }

    return (
        <div className="filter">
            <input type="checkbox" checked={filter.active} onChange={handleToggleFilter}></input>
            <p>{filter.searchTarget} contains {filter.searchTerm}</p>
            <div className="delete-filter" onClick={handleDeleteFilterClick}>X</div>
        </div>
    )
}